// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yjTNO","content":"styles_content__2aaGz"};